"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = require("@material-ui/core");
var services_1 = require("@pbl/pbl-react-core/lib/services");
var EarnPointsModal_1 = __importDefault(require("@pbl/pbl-react-web-components/lib/earn/EarnPointsModal"));
var hideable_1 = require("@pbl/pbl-react-web-components/lib/hideable");
var package_1 = require("@pbl/pbl-react-web-components/lib/package");
var SurveyContent_1 = __importDefault(require("@pbl/pbl-react-web-components/lib/survey/pbl/SurveyContent"));
var react_1 = __importStar(require("react"));
var react_i18next_1 = require("react-i18next");
var react_redux_1 = require("react-redux");
var colors_1 = __importDefault(require("../../assets/jss/colors"));
var constants_1 = require("../../config/constants");
var actions_1 = require("../../redux/reducers/app/actions");
var actions_2 = require("../../redux/reducers/loyalty/actions");
var actions_3 = require("../../redux/reducers/survey/actions");
var useActivityDetailsData_1 = require("../../shared/hooks/providers/useActivityDetailsData");
var useScrollToTop_1 = require("../../shared/hooks/useScrollToTop");
var errorsUtils_1 = require("../../utils/errorsUtils");
var framework_1 = require("../../widgets/framework");
var styles_1 = __importDefault(require("./styles"));
var PollScreen = function (_a) {
    var _b;
    var classes = _a.classes, t = _a.t, identifier = _a.identifier;
    var dispatch = (0, react_redux_1.useDispatch)();
    var theme = (0, core_1.useTheme)();
    var activityId = "".concat(identifier);
    var _c = (0, react_redux_1.useSelector)(function (state) { return state.authentication; }), isLoggedIn = _c.isAuthenticated, isRestricted = _c.isRestricted;
    var _d = (0, react_1.useState)(true), isLoadingData = _d[0], setIsLoadingData = _d[1];
    var _e = (0, react_1.useState)(false), showErrorModal = _e[0], setShowErrorModal = _e[1];
    var _f = (0, react_1.useState)(false), showSuccessModal = _f[0], setShowSuccessModal = _f[1];
    var _g = (0, react_1.useState)(null), selectedActivity = _g[0], setSelectedActivity = _g[1];
    var _h = (0, react_1.useState)(null), poll = _h[0], setPoll = _h[1];
    var _j = (0, react_1.useState)({
        id: 0,
        questionText: '',
        questionType: '',
        optional: false,
        surveyId: 0,
        playersAnswerId: 0,
        options: [],
        totalResponse: 0
    }), pollPostResponse = _j[0], setPollPostResponse = _j[1];
    var _k = (0, react_1.useState)({ surveyId: 0, responses: [] }), userResponse = _k[0], setUserResponse = _k[1];
    var _l = (0, react_1.useState)({}), pollResult = _l[0], setPollResult = _l[1];
    (0, useScrollToTop_1.useScrollToTop)();
    var navigateToActivities = (0, react_1.useCallback)(function (message) {
        var appNavigate = {
            action: 'ACTIVITIES',
            data: message
        };
        framework_1.GoFwInternalInstance.onHostNavigate(appNavigate);
    }, []);
    var redirectToLogin = function () {
        framework_1.GoFwInternalInstance.onHostLogin();
    };
    var redirectContactUs = function () {
        var appNavigate = {
            action: 'CONTACT_US'
        };
        framework_1.GoFwInternalInstance.onHostNavigate(appNavigate);
    };
    var showInvalidError = (0, react_1.useCallback)(function () {
        navigateToActivities({
            message: t('activities.activityUnavailable'),
            type: 'warning',
            messageTimeout: 3000
        });
    }, [navigateToActivities, t]);
    var activity = (0, useActivityDetailsData_1.useActivityDetailsData)(activityId, isLoggedIn, showInvalidError).activity;
    (0, react_1.useEffect)(function () {
        if (activity) {
            var getPoll = function (activityEntity) { return __awaiter(void 0, void 0, void 0, function () {
                var pollEntity;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4, services_1.SurveyService.getSurvey(activityEntity.key)];
                        case 1:
                            pollEntity = _a.sent();
                            if (pollEntity) {
                                setPoll(pollEntity);
                                setSelectedActivity(activityEntity);
                                setIsLoadingData(false);
                                dispatch((0, actions_1.toggleLoading)({
                                    spinning: false
                                }));
                            }
                            return [2];
                    }
                });
            }); };
            getPoll(activity);
        }
        return function () {
            dispatch((0, actions_2.resetState)());
        };
    }, [activity, dispatch]);
    var onChange = function (answer) {
        var newResponses = userResponse.responses
            ? userResponse.responses.filter(function (response) { return response.questionId !== answer.questionId; })
            : [];
        setUserResponse({ surveyId: poll === null || poll === void 0 ? void 0 : poll.id, responses: __spreadArray(__spreadArray([], newResponses, true), [answer], false) });
    };
    var validateResponse = function (response) { return __awaiter(void 0, void 0, void 0, function () {
        var _a;
        return __generator(this, function (_b) {
            setIsLoadingData(false);
            dispatch((0, actions_1.toggleLoading)({
                spinning: false
            }));
            if (response && 'errorKey' in response && response.errorKey) {
                dispatch((0, actions_1.showMessageBar)({
                    message: response.errorKey && response.errorKey === 'responded-already'
                        ? t('error.activity.respondedAlready')
                        : (0, errorsUtils_1.toCamelCase)(response.errorKey),
                    type: 'error',
                    messageTimeout: 10000
                }));
            }
            else if ((_a = response === null || response === void 0 ? void 0 : response.detail) === null || _a === void 0 ? void 0 : _a.includes('invalidAccess')) {
                dispatch((0, actions_1.showMessageBar)({
                    message: t('error.activity.invalidAccess'),
                    type: 'error',
                    messageTimeout: 10000
                }));
            }
            else if (response && selectedActivity) {
                setPollResult(response);
                if (response &&
                    'message' in response &&
                    response.message &&
                    /^error:.*/i.test(response.message)) {
                    setShowErrorModal(true);
                }
                else {
                    if ('points' in response && response.points === 0) {
                        dispatch((0, actions_1.showMessageBar)({
                            message: t('poll.submitted')
                        }));
                    }
                    else {
                        setShowSuccessModal(true);
                    }
                }
            }
            return [2];
        });
    }); };
    var postPoll = function () { return __awaiter(void 0, void 0, void 0, function () {
        var submitResponse, updatedPollPostResponse;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    if (!isLoggedIn) {
                        redirectToLogin();
                        return [2];
                    }
                    setIsLoadingData(true);
                    dispatch((0, actions_1.toggleLoading)({
                        spinning: true,
                        label: t('poll.loading')
                    }));
                    return [4, (0, actions_3.submitPoll)(userResponse)];
                case 1:
                    submitResponse = _a.sent();
                    return [4, validateResponse(submitResponse)];
                case 2:
                    _a.sent();
                    dispatch((0, actions_2.fetchUserPoints)());
                    updatedPollPostResponse = submitResponse.userResponses && submitResponse.userResponses[0];
                    if (updatedPollPostResponse) {
                        updatedPollPostResponse.playersAnswerId =
                            submitResponse.results && submitResponse.results[0].answerId;
                        setPollPostResponse(updatedPollPostResponse);
                        setIsLoadingData(false);
                        dispatch((0, actions_1.toggleLoading)({
                            spinning: false
                        }));
                    }
                    return [2];
            }
        });
    }); };
    var getBackgroundColors = function (index, pollPostResponseEntity) {
        var selectedIndex = pollPostResponseEntity.options.findIndex(function (item) { return item.id === pollPostResponseEntity.playersAnswerId; });
        if (index === selectedIndex) {
            return colors_1.default.poll.selected.hex();
        }
        var currentIndex = index < selectedIndex ? index : index - 1;
        var val = currentIndex % 4;
        switch (val) {
            case 0:
                return colors_1.default.poll.first.hex();
            case 1:
                return colors_1.default.poll.second.hex();
            case 2:
                return colors_1.default.poll.third.hex();
            case 3:
                return colors_1.default.poll.fourth.hex();
            default:
                return colors_1.default.poll.fourth.hex();
        }
    };
    var percentage = function (partialValue, totalValue) {
        return totalValue === 0 ? totalValue : Math.round((100 * partialValue) / totalValue);
    };
    var getContent = function () { return (react_1.default.createElement(core_1.Grid, { item: true, xs: 12 }, (pollPostResponse === null || pollPostResponse === void 0 ? void 0 : pollPostResponse.id) ? (pollPostResponse.options.map(function (result, index) { return (react_1.default.createElement("div", { className: classes.pollOption, key: index },
        react_1.default.createElement(core_1.Typography, { variant: 'body2', className: classes.pollAnswer, style: { color: theme.palette.text.primary } }, "".concat(percentage(result.totalResponse, pollPostResponse.totalResponse), "% ").concat(result.optionText)),
        react_1.default.createElement("div", { className: classes.pollBackground, style: {
                width: "".concat(Math.max(percentage(result.totalResponse, pollPostResponse.totalResponse), 5), "%"),
                backgroundColor: pollPostResponse.playersAnswerId === result.id
                    ? colors_1.default.poll.selected.hex()
                    : getBackgroundColors(index, pollPostResponse),
                opacity: 0.75
            } }))); })) : (react_1.default.createElement(SurveyContent_1.default, { onSaveSurvey: postPoll, onChange: onChange, survey: poll, playerResponses: userResponse.responses, isLoading: isLoadingData, isSystemSurvey: false, bonusPoints: selectedActivity === null || selectedActivity === void 0 ? void 0 : selectedActivity.bonusAmount, amount: selectedActivity === null || selectedActivity === void 0 ? void 0 : selectedActivity.amount, limitReached: false, isRestricted: isLoggedIn && isRestricted, handleContactUs: redirectContactUs, isLoggedIn: isLoggedIn, showSignInWarning: !isLoggedIn && constants_1.RemoteConstants.getBoolean('SHOW_SIGN_IN_WARNING') })))); };
    var dismissModals = function (updatePoints) {
        if (updatePoints === void 0) { updatePoints = false; }
        if (updatePoints) {
            framework_1.GoFwInternalInstance.onEarnActivity();
        }
        setShowErrorModal(false);
        setShowSuccessModal(false);
    };
    if (!selectedActivity) {
        return null;
    }
    return (react_1.default.createElement("div", null,
        react_1.default.createElement(hideable_1.Hideable, { show: Boolean(pollResult && pollResult.points && showSuccessModal) },
            react_1.default.createElement(EarnPointsModal_1.default, { pointEarned: pollResult.points, isVisible: true, onClose: function () { return dismissModals(true); }, successHeadingMsg: poll === null || poll === void 0 ? void 0 : poll.message })),
        react_1.default.createElement(hideable_1.Hideable, { show: showErrorModal },
            react_1.default.createElement(package_1.InfoModal, { isVisible: true, heading: t('poll.infoErrorModal.heading'), message: t('poll.infoErrorModal.message'), buttonText: t('poll.infoErrorModal.buttonText'), onClose: dismissModals })),
        react_1.default.createElement("div", { className: classes.container }, isLoadingData ? (react_1.default.createElement(package_1.AppSpinner, { label: t('poll.loading') })) : (poll && (react_1.default.createElement(core_1.Grid, { className: classes.container, container: true, spacing: 2 },
            react_1.default.createElement(core_1.Grid, { item: true, xs: 12 },
                react_1.default.createElement(package_1.EarnActivityHeader, { data: {
                        image: selectedActivity.imageUrl,
                        title: selectedActivity.title,
                        description: selectedActivity.description || '',
                        points: selectedActivity.amount || 0,
                        preview_url: selectedActivity.videoUrl ? selectedActivity.videoUrl : undefined,
                        isCoverImage: true
                    }, hideBackBtn: true, bonusPoints: (_b = selectedActivity.bonusAmount) !== null && _b !== void 0 ? _b : 0, navigateTo: navigateToActivities, showSignInWarning: !isLoggedIn && constants_1.RemoteConstants.getBoolean('SHOW_SIGN_IN_WARNING'), redirectToLogin: postPoll }),
                getContent())))))));
};
exports.default = (0, react_i18next_1.withTranslation)()((0, core_1.withStyles)(styles_1.default)(PollScreen));
//# sourceMappingURL=index.js.map